import { goBack } from 'connected-react-router';
import { reconnectWS } from 'modules/websocket/WSManager';
import { redirectTo } from 'modules/auth/actions/redirectAction';
import { clearModalQueue } from 'modules/messageSystem/actions/clearModalQueue';
import { conferenceInProgress } from 'modules/conference/selectors/consultationInfo';
import { setReconnectionStatus } from 'modules/conference/actions/consultationLifecycle';
import { fetchActiveConversations } from 'modules/session/actions/fetchActiveConversations';
import { logAppointmentParticipantsEvents } from 'modules/common/actions/logAppointmentParticipantsEvents';


const handleOnline = () => (dispatch, getState) => {
  const state = getState();

  if (state.session.sessionInfo.sessionId) {
    return fetchActiveConversations()
      .then(({ appointmentId }) => {
        const isConsultationInProgressAtBEside = !!appointmentId;
        const isConsultationInProgressAtFEside = conferenceInProgress(state);

        if (isConsultationInProgressAtBEside && !isConsultationInProgressAtFEside) {
          return null;
        }
      });
  }
};

export const handleOffline = (dispatch, getState) => {
  const state = getState();
  localStorage.setItem('offline_started', new Date().toString());
  if (conferenceInProgress(state)) {
    return dispatch(setReconnectionStatus());
  }

  dispatch(clearModalQueue());
  // return redirectTo('/noInternet');
};

export const onRestore = () => (dispatch, getState) => {
  const state = getState();

  if (!localStorage.getItem('offline_started')) return null;

  const { appointmentId } = state.appointmentInfo.currentAppointment;

  if (appointmentId) {
    const date = localStorage.getItem('offline_started');
    localStorage.removeItem('offline_started');

    dispatch(logAppointmentParticipantsEvents({
      appointmentId,
      eventType: 'NO_INTERNET_CONNECTION',
      startAt: new Date(date).getTime(),
      endAt: new Date().getTime(),
    }));
  }

  if (/\/(noInternet)/.test(window.location.pathname)) {
    Promise.resolve()
      .then(() => dispatch(handleOnline()))
      .then(() => dispatch(goBack()));
  }
};

export const startObserveInternetConnection = () => dispatch => {
  const offline = () => dispatch(handleOffline);

  function changeNetworkTypeHandler() {
    if (navigator.onLine) reconnectWS();
  }

  if (navigator.connection?.ontypechange) {
    navigator.connection.ontypechange = changeNetworkTypeHandler;
  }

  window.addEventListener('offline', offline);
};
